import { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import EventServices from "../services/EventServices";
import useAsync from "../hooks/useAsync";
import Modal from "react-modal";
import DeleteButton from "./Button/DeleteButton";
import EventUpdate from "./Update Model/UpdateEvent";
import ViewEvent from "./View Model/ViewEvent";
import Pagination from "./Common/Pagination";
import EventStatus from "./TogelButton/TogalButtonForStatus";
Modal.setAppElement("#root");
function EventList() {
    const [currentPage, setCurrentPage] = useState(1);
    const [limit] = useState(10);
    const fetchEvents = useCallback(() => {
        return EventServices.getEvent(currentPage, limit);
    }, [currentPage, limit]);

    const {data, error,loading: isLoading,run,} = useAsync(fetchEvents);
    const events = data?.data || [];

    const pagination = data?.pagination || {};

    const totalPages = pagination?.totalPages || 0;

    const totalItems = pagination?.total || 0;

    const count = totalItems;
    const [activeIndex, setActiveIndex] =
        useState(null);
    const [isEditModalOpen, setIsEditModalOpen] =
        useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] =
        useState(false);

    const [isModalOpen, setIsModalOpen] =
        useState(false);

    const [selectedEdit, setSelectedEdit] =
        useState(null);

    const [selectedEvent, setSelectedEvent] =
        useState(null);
    const toggleActionMenu = (index) => {

        setActiveIndex(
            index === activeIndex
                ? null
                : index
        );
    };

    // ==========================================
    // EDIT
    // ==========================================
    const handleEditDetails = (event) => {

        setSelectedEdit(event);

        setIsEditModalOpen(true);

        toggleActionMenu(null);
    };

    // ==========================================
    // DELETE
    // ==========================================
    const handleDelete = (event) => {

        setSelectedEdit(event);

        setIsDeleteModalOpen(true);

        toggleActionMenu(null);
    };

    const handleViewDetails = (event) => {

        setSelectedEvent(event);

        setIsModalOpen(true);

        toggleActionMenu(null);
    };

    // ==========================================
    // CLOSE EDIT
    // ==========================================
    const closeEditModal = () => {

        setIsEditModalOpen(false);

        setSelectedEdit(null);
    };

    const closeDeleteModal = () => {

        setIsDeleteModalOpen(false);

        setSelectedEdit(null);
    };
    const closeModal = () => {

        setIsModalOpen(false);

        setSelectedEvent(null);
    };

    // ==========================================
    // DATE FORMAT
    // ==========================================
    function formatDateTime(dateValue) {

        if (!dateValue) {
            return "N/A";
        }

        const date = new Date(dateValue);

        if (isNaN(date.getTime())) {
            return "N/A";
        }

        return date.toLocaleDateString("en-IN");
    }

    // ==========================================
    // LOADING
    // ==========================================
    if (isLoading) {
        return (
            <div className="right_col" role="main">
                <div className="container-box">
                    <div className="container-box-inner">
                        <p>Loading events...</p>
                    </div>
                </div>
            </div>
        );
    }

    // ==========================================
    // UI
    // ==========================================
    return (
        <>
            <div
                className="right_col"
                role="main"
            >

                {/* =================================
                    HEADER
                ================================== */}
                <div className="title-box">

                    <h2>
                        Events List{" "}

                        <span className="badge bg-orange">
                            {count}
                        </span>
                    </h2>

                    <div className="container-box-top-header-right">

                        <Link
                            className="round-add-btn"
                            to="/create-event"
                        >
                            <img
                                src="img/plus.svg"
                                alt=""
                            />
                        </Link>

                    </div>

                </div>


                {/* =================================
                    TABLE
                ================================== */}
                <div className="container-box px-0 pt-2">

                    <div className="container-box-inner table-reponsive-tabe">

                        <table
                            id="example"
                            className="table table-striped"
                            style={{
                                width: "100%"
                            }}
                        >

                            <thead>

                                <tr>
                                    <th>#</th>
                                    <th>Title</th>
                                    <th>Image</th>
                                    <th>Date</th>
                                    <th>Venue</th>
                                    <th>City</th>
                                    <th>Status</th>
                                    <th>Change Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {events.map(
                                    (event, i) => (
                                        <tr
                                            key={
                                                event?._id ||
                                                event?.id ||
                                                i
                                            }
                                        >
                                            <td>
                                                {(Number(currentPage) - 1) * Number(limit) + i + 1}
                                            </td>
                                            <td>{event?.eventName ||
                                                "N/A"}
                                            </td>
                                            <td>
                                                <div className="product-img">
                                                    {event?.eventBanner ? (
                                                        <img
                                                            src={process.env.REACT_APP_URL + event.eventBanner}
                                                            alt={
                                                                event?.eventBanner ||
                                                                "Event"
                                                            }
                                                        // style={{                                                                height:
                                                        //         "70px",
                                                        //     width:
                                                        //         "70px",
                                                        //     objectFit:
                                                        //         "contain"
                                                        // }}
                                                        />

                                                    ) : (

                                                        <span>
                                                            N/A
                                                        </span>

                                                    )}

                                                </div>

                                            </td>
                                            <td>
                                                {formatDateTime(
                                                    event?.eventDate ||
                                                    event?.createdAt
                                                )}
                                            </td>
                                            <td>
                                                {event?.venue ||
                                                    "N/A"}
                                            </td>
                                            <td>
                                                {event?.city?.name ||
                                                    event?.city ||
                                                    "N/A"}
                                            </td>
                                            <td className="status-toggle">
                                                <span
                                                    className={event?.status === "Active" ? "badge bg-success" : "badge bg-secondary"}                                              >
                                                    {event?.status || "N/A"}
                                                </span>
                                            </td>
                                            <td className="status-toggle">
                                                <EventStatus data={event} page="event" onSuccess={() => run()} />
                                            </td>
                                            <td>
                                                <div className="action_toggle_outer">
                                                    <button className="action_toggle"
                                                        onClick={() =>
                                                            toggleActionMenu(
                                                                i
                                                            )
                                                        }
                                                    >
                                                        <i className="fa fa-ellipsis-v" />
                                                    </button>
                                                    {activeIndex === i && (
                                                        <div className="action_toggle_content product-edit show d-block">
                                                            <ul className="list-unstyled">
                                                                <li>
                                                                    <button
                                                                        className="close_toggle"
                                                                        onClick={() =>
                                                                            toggleActionMenu(
                                                                                null
                                                                            )
                                                                        }
                                                                    >
                                                                        <i className="fa fa-close" />
                                                                    </button>
                                                                </li>
                                                                <li>
                                                                    <button
                                                                        className="approve" style={{ backgroundColor: '#263238' }}
                                                                        onClick={() =>
                                                                            handleViewDetails(
                                                                                event
                                                                            )
                                                                        }
                                                                    >
                                                                        View
                                                                    </button>
                                                                </li>
                                                                <li>
                                                                    <button
                                                                        className="edit"
                                                                        onClick={() =>
                                                                            handleEditDetails(
                                                                                event
                                                                            )
                                                                        }
                                                                    >
                                                                        Edit
                                                                    </button>
                                                                </li>
                                                                <li>
                                                                    <button
                                                                        className="reject"
                                                                        onClick={() =>
                                                                            handleDelete(
                                                                                event
                                                                            )
                                                                        }
                                                                    >
                                                                        Delete
                                                                    </button>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>

                                    )
                                )}

                            </tbody>

                        </table>

                    </div>

                </div>
                <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={setCurrentPage}
                />

                {/* =================================
                    EDIT MODAL
                ================================== */}
                <Modal
                    isOpen={isEditModalOpen}
                    onRequestClose={closeEditModal}
                    contentLabel="Event Edit"
                    className="modal-content"
                    overlayClassName="modal-overlay"
                >

                    <EventUpdate
                        user={selectedEdit}
                        closeModal={closeEditModal}
                        onSuccess={run}
                    />

                </Modal>


                {/* =================================
                    VIEW MODAL
                ================================== */}
                <Modal
                    isOpen={isModalOpen}
                    onRequestClose={closeModal}
                    contentLabel="View Event"
                    className="modal-content"
                    overlayClassName="modal-overlay"
                >

                    <ViewEvent
                        user={selectedEvent}
                        closeModal={closeModal}
                    />

                </Modal>


                {/* =================================
                    DELETE MODAL
                ================================== */}
                <Modal
                    isOpen={isDeleteModalOpen}
                    onRequestClose={closeDeleteModal}
                    contentLabel="Delete Confirmation"
                    className="modal-content"
                    overlayClassName="modal-overlay"
                >

                    <DeleteButton
                        data={selectedEdit}
                        page="delete-event"
                        closeModal={closeDeleteModal}
                        onSuccess={run}
                    />

                </Modal>

            </div>
        </>
    );
}

export default EventList;